import { get } from '../../../../GlobalModules/Utility/Http';

/**
 * Get product addon groups
 * @param {string} productSlack - Product slack ID
 * @returns {Promise} Addon groups for the product
 */
export const getProductAddonGroups = async (productSlack) => {
  try {
    const response = await get(`${process.env.EXTENDED_URL}/addon_group_product/${productSlack}`);

    if (response.data && response.data.status === 200) {
      // Process the response to extract addon groups and their products
      const addonGroupsData = response.data.data;

      // Transform the data into a format that matches our component expectations
      // Group by AddonGroup ID to consolidate products under the same group
      const groupedByAddonGroup = {};

      addonGroupsData.forEach(item => {
        const addonGroup = item.AddonGroup;
        const addonGroupId = addonGroup.id;

        // Initialize the group if not already done
        if (!groupedByAddonGroup[addonGroupId]) {
          groupedByAddonGroup[addonGroupId] = {
            id: addonGroupId,
            slack: addonGroup.slack,
            addon_group_label: addonGroup.label,
            addon_group_code: addonGroup.addon_group_code,
            multiple_selection: addonGroup.multiple_selection,
            products: []
          };
        }

        // Add all products from AddonProducts to the group
        addonGroup.AddonProducts.forEach(addonProduct => {
          const product = addonProduct.Product;
          groupedByAddonGroup[addonGroupId].products.push({
            slack: product.slack,
            product_code: product.product_code,
            name: product.name,
            sale_amount_excluding_tax: product.sale_amount_excluding_tax,
            is_addon_product: product.is_addon_product
          });
        });
      });

      // Convert the grouped object back to an array
      const formattedAddonGroups = Object.values(groupedByAddonGroup);

      return {
        success: true,
        data: formattedAddonGroups
      };
    }

    return {
      success: false,
      message: response.data?.message || 'Failed to fetch addon groups'
    };
  } catch (error) {
    console.error('Error fetching product addon groups:', error);
    return {
      success: false,
      message: error.message || 'Error fetching addon groups'
    };
  }
};
